import { UnitOfMeasureType } from '../../item/enum/UnitOfMeasureType';
import { BatchStatus } from './batch';

export const BATCH_UOM = UnitOfMeasureType.Kg;

export const BATCH_STATUS_TRANSITIONS: Partial<Record<BatchStatus, BatchStatus[]>> = {
  [BatchStatus.Draft]: [BatchStatus.Draft, BatchStatus.Approved],
  [BatchStatus.Approved]: [BatchStatus.Approved, BatchStatus.ReadyForProduction],
  [BatchStatus.ReadyForProduction]: [BatchStatus.ReadyForProduction, BatchStatus.InProduction],
  // Completed is set by the API when a dyeing cycle with approved QC is unloaded, never from the selector.
  [BatchStatus.InProduction]: [BatchStatus.InProduction],
  [BatchStatus.Completed]: [BatchStatus.Completed, BatchStatus.Closed],
};

export const ENTITY_DEF_PRODUCTION_WORK_ORDER = 40;
export const ENTITY_DEF_BATCH = 41;
